export default __webpack_public_path__ + "static/media/Major Rune Stone of the Furious Swipe (V).1857e9c4.jpg";